import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  NewsDetailsState,
  NewsDetailsAction,
  NewsDetailsReducer,
} from './news-details-reducer';

const initialState: NewsDetailsState = {
  newsDetails: null,
  loading: false,
  error: null,
};

const NewsDetailsStateContext = createContext<NewsDetailsState | undefined>(undefined);
const NewsDetailsDispatchContext = createContext<React.Dispatch<NewsDetailsAction> | undefined>(undefined);

interface NewsDetailsProviderProps {
  children: ReactNode;
}

export const NewsDetailsProvider: React.FC<NewsDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(NewsDetailsReducer, initialState);

  return (
    <NewsDetailsStateContext.Provider value={state}>
      <NewsDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </NewsDetailsDispatchContext.Provider>
    </NewsDetailsStateContext.Provider>
  );
};

export const useNewsDetailsState = (): NewsDetailsState => {
  const context = useContext(NewsDetailsStateContext);
  if (context === undefined) {
    throw new Error('useNewsDetailsState must be used within a NewsDetailsProvider');
  }
  return context;
};

export const useNewsDetailsDispatch = (): React.Dispatch<NewsDetailsAction> => {
  const context = useContext(NewsDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useNewsDetailsDispatch must be used within a NewsDetailsProvider');
  }
  return context;
};